/**
 * Merchant kitchen / dashboard should only see paid food orders and reservations.
 * Keep in sync with backend/lib/orderVisibility.js.
 */
export function isMerchantVisibleOrder(order) {
  if (!order) return false;
  if (order.fulfillment_type === "reservation") return true;
  const paymentStatus = order.payment_status;
  if (paymentStatus === "paid" || paymentStatus === "not_required") return true;
  if (
    paymentStatus === "payment_pending"
    || paymentStatus === "payment_failed"
    || paymentStatus === "payment_canceled"
  ) {
    return false;
  }
  return true;
}

export function isUnpaidCheckoutOrder(order) {
  const paymentStatus = order?.payment_status;
  return paymentStatus === "payment_pending"
    || paymentStatus === "payment_failed"
    || paymentStatus === "payment_canceled";
}

export function isFoodOrder(order) {
  return Boolean(order) && order.fulfillment_type !== "reservation" && isMerchantVisibleOrder(order);
}
